import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';
import {normalize, truthyWinsMergeStrategy} from '../../util/utils';
import {HttpStatusCodes} from '../../util/uiconstants';
import {labels} from '../../util/utils';

const filterStatefunc = (state, includeArray) => {
	const byId = state.byId;
	const obArr = Object.values(byId).filter((fs) => !includeArray?.includes(fs.financialStatementTypeId));
	return normalize(obArr);
};

export function financialStatementReducer(state = initialstate.financialStatement, action) {
	switch (action.type) {
		case types.GET_TRIAL_BALANCE:
			if (action.response && action.responseObj.status === HttpStatusCodes.Ok) {
				let financialStatements = [];

				action.response.map((tb) => {
					financialStatements = financialStatements
						.concat(tb.firstLevelFinancialStatements)
						?.concat(tb.secondLevelFinancialStatements)
						?.concat(tb.thirdLevelFinancialStatements)
						?.concat(tb.fourthLevelFinancialStatements?.data);
				});

				financialStatements = financialStatements?.map((financial) => ({
					...financial,
					annotations: financial.annotations?.map((annotation) => annotation.id),
					isSelected: false
				}));

				const normalizedFilteredState = filterStatefunc(state, action.includeArray);

				return {
					...normalize(financialStatements, undefined, normalizedFilteredState, truthyWinsMergeStrategy)
				};
			}
			return state;
		case types.GET_TRIAL_BALANCE_BY_ID:
			if (action.response && action.responseObj.status === HttpStatusCodes.Ok) {
				let financialStatements = [];

				action.response.map((tb) => {
					financialStatements = financialStatements
						.concat(tb.firstLevelFinancialStatements)
						?.concat(tb.secondLevelFinancialStatements)
						?.concat(tb.thirdLevelFinancialStatements)
						?.concat(tb.fourthLevelFinancialStatements?.data);
				});

				financialStatements = financialStatements?.map((financial) => ({
					...financial,
					annotations: financial.annotations?.map((annotation) => annotation.id),
					isSelected: false
				}));

				const normalizedFilteredState = filterStatefunc(state, action.includeArray);

				return {
					...normalize(financialStatements, undefined, normalizedFilteredState, truthyWinsMergeStrategy)
				};
			}
			return state;
		// case types.OPEN_ANNOTATION_MODAL: {
		// 	const financialStatementId = action.financialStatementId;
		// 	return {
		// 		...state,
		// 		byId: {
		// 			...state.byId,
		// 			[financialStatementId]: {
		// 				...state.byId[financialStatementId],
		// 				isSelected: true
		// 			}
		// 		}
		// 	};
		// }
		// case types.CLEAR_ANNOTATION_MODAL: {
		// 	const slice = state.byId;
		// 	const financialStatements = Object.values(slice).map((financial) => {
		// 		return {...financial, isSelected: false};
		// 	});
		// 	return {
		// 		...normalize(financialStatements)
		// 	};
		// }
		// case types.CREATE_ENTITY_ANNOTATION: {
		// 	if (action.responseObj.status === HttpStatusCodes.Created) {
		// 		// add newly added annotation into financialStatement list
		// 		const financialStatementId = action.annotation.financialStatementId;
		// 		return {
		// 			...state,
		// 			byId: {
		// 				...state.byId,
		// 				[financialStatementId]: {
		// 					...state.byId[financialStatementId],
		// 					annotations: [action.response.id]
		// 				}
		// 			}
		// 		};
		// 	}
		// 	return state;
		// }
		// case types.DELETE_ENTITY_ANNOTATION: {
		// 	if (action.responseObj.status === HttpStatusCodes.NoContent) {
		// 		// delete deleted annotation from financialStatement list
		// 		const financialStatementId = action.annotation.financialStatementId;
		// 		return {
		// 			...state,
		// 			byId: {
		// 				...state.byId,
		// 				[financialStatementId]: {
		// 					...state.byId[financialStatementId],
		// 					annotations: []
		// 				}
		// 			}
		// 		};
		// 	}
		// 	return state;
		// }
		default:
			return state;
	}
}
